import SeoLandingLayout from './components/SeoLandingLayout';

export default function NutricionistaPalmaPageShort() {
  return (
    <SeoLandingLayout
      title="Nutricionista en Palma | Dario Rojas"
      description="Nutricionista en Palma para perder grasa, mejorar habitos y cuidar tu salud digestiva con planes personalizados y seguimiento."
      canonicalPath="/nutricionista-palma"
      heading="Nutricionista en Palma para mejorar tu salud"
      intro="Trabajo con personas de Palma que quieren mejorar su alimentacion de forma realista. Definimos objetivos claros y una estrategia nutricional sostenible para tu dia a dia."
      bullets={[
        'Plan personalizado segun tu objetivo y estilo de vida',
        'Educacion nutricional para resultados duraderos',
        'Seguimiento continuo y ajustes segun progreso',
        'Enfoque practico para mejorar energia y bienestar',
      ]}
      sections={[
        {
          title: 'Nutricionista Palma con enfoque practico',
          paragraphs: [
            'Si buscas nutricionista en Palma, necesitas un plan que puedas cumplir en tu vida diaria. Por eso la estrategia se adapta a tus horarios, gustos y nivel de compromiso.',
            'Priorizamos cambios sostenibles que mejoran salud, energia y composicion corporal sin depender de dietas rigidas.',
          ],
        },
      ]}
      faqItems={[
        {
          question: 'Que incluye una consulta con nutricionista en Palma?',
          answer:
            'Incluye evaluacion inicial, objetivos nutricionales, propuesta de plan y recomendaciones personalizadas.',
        },
        {
          question: 'Puedo hacer seguimiento online si viajo o tengo poco tiempo?',
          answer:
            'Si, el seguimiento online permite continuidad aunque cambie tu agenda.',
        },
      ]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'MedicalBusiness',
        name: 'Dario Rojas Nutricion',
        url: 'https://dariorojasnutricion.es/nutricionista-palma',
        areaServed: 'Palma de Mallorca',
        telephone: '+34 685546738',
        email: 'dariorojasnutricion@gmail.com',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Palma de Mallorca',
          addressCountry: 'ES',
        },
      }}
    />
  );
}
